 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"dimforge-rapier3d":"dimforge-rapier3d"}[chunkId]||chunkId) + ".js"
 	}

 	// object to store loaded and loading wasm modules
 	var installedWasmModules = {};

 	function promiseResolve() { return Promise.resolve(); }

 	var wasmImportObjects = {
 		"./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.wasm": function() {
 			return {
 				"./rapier_wasm3d_bg.js": {
 					"__wbindgen_object_drop_ref": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbindgen_object_drop_ref"](p0i32);
 					},
 					"__wbindgen_number_new": function(p0f64) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbindgen_number_new"](p0f64);
 					},
 					"__wbindgen_number_get": function(p0i32,p1i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbindgen_number_get"](p0i32,p1i32);
 					},
 					"__wbindgen_boolean_get": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbindgen_boolean_get"](p0i32);
 					},
 					"__wbindgen_is_function": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbindgen_is_function"](p0i32);
 					},
 					"__wbg_rawraycolliderintersection_new": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_rawraycolliderintersection_new"](p0i32);
 					},
 					"__wbg_rawcontactforceevent_new": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_rawcontactforceevent_new"](p0i32);
 					},
 					"__wbg_call_168da88779e35f61": function(p0i32,p1i32,p2i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_call_168da88779e35f61"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_call_3999bee59e9f7719": function(p0i32,p1i32,p2i32,p3i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_call_3999bee59e9f7719"](p0i32,p1i32,p2i32,p3i32);
 					},
 					"__wbg_call_e1f72c051cdab859": function(p0i32,p1i32,p2i32,p3i32,p4i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_call_e1f72c051cdab859"](p0i32,p1i32,p2i32,p3i32,p4i32);
 					},
 					"__wbg_bind_10dfe70e95d2a480": function(p0i32,p1i32,p2i32,p3i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_bind_10dfe70e95d2a480"](p0i32,p1i32,p2i32,p3i32);
 					},
 					"__wbg_buffer_3f3d764d4747d564": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_buffer_3f3d764d4747d564"](p0i32);
 					},
 					"__wbg_newwithbyteoffsetandlength_d9aa266703cb98be": function(p0i32,p1i32,p2i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_newwithbyteoffsetandlength_d9aa266703cb98be"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_new_8c3f0052272a457a": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_new_8c3f0052272a457a"](p0i32);
 					},
 					"__wbg_set_83db9690f9353e79": function(p0i32,p1i32,p2i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_set_83db9690f9353e79"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_length_9e1ae1900cb0fbd5": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_length_9e1ae1900cb0fbd5"](p0i32);
 					},
 					"__wbg_newwithbyteoffsetandlength_be22e5fcf4f69ab4": function(p0i32,p1i32,p2i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_newwithbyteoffsetandlength_be22e5fcf4f69ab4"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_set_0e0314cf6675c1b9": function(p0i32,p1i32,p2i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_set_0e0314cf6675c1b9"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_length_9a2deed95d22668d": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_length_9a2deed95d22668d"](p0i32);
 					},
 					"__wbg_newwithlength_a7168e4a1e8f5e12": function(p0i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbg_newwithlength_a7168e4a1e8f5e12"](p0i32);
 					},
 					"__wbindgen_throw": function(p0i32,p1i32) {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbindgen_throw"](p0i32,p1i32);
 					},
 					"__wbindgen_memory": function() {
 						return installedModules["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.js"].exports["__wbindgen_memory"]();
 					}
 				}
 			};
 		},
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// Fetch + compile chunk loading for webassembly

 		var wasmModules = {"dimforge-rapier3d":["./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.wasm"]}[chunkId] || [];

 		wasmModules.forEach(function(wasmModuleId) {
 			var installedWasmModuleData = installedWasmModules[wasmModuleId];

 			// a Promise means "currently loading" or "already loaded".
 			if(installedWasmModuleData)
 				promises.push(installedWasmModuleData);
 			else {
 				var importObject = wasmImportObjects[wasmModuleId]();
 				var req = fetch(__webpack_require__.p + "" + {"./node_modules/@dimforge/rapier3d/rapier_wasm3d_bg.wasm":"f3ddea01f4799303712c"}[wasmModuleId] + ".module.wasm");
 				var promise;
 				if(importObject instanceof Promise && typeof WebAssembly.compileStreaming === 'function') {
 					promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
 						return WebAssembly.instantiate(items[0], items[1]);
 					});
 				} else if(typeof WebAssembly.instantiateStreaming === 'function') {
 					promise = WebAssembly.instantiateStreaming(req, importObject);
 				} else {
 					var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
 					promise = bytesPromise.then(function(bytes) {
 						return WebAssembly.instantiate(bytes, importObject);
 					});
 				}
 				promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
 					return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
 				}));
 			}
 		});
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// object with all WebAssembly.instance exports
 	__webpack_require__.w = {};

 	var jsonpArray = (typeof self!='undefined'?self:global)["webpackJsonp"] = (typeof self!='undefined'?self:global)["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
